import { redirect, type LoaderFunctionArgs } from "react-router-dom";

function hasCachedMsalAccount(): boolean {
  if (typeof window === "undefined") {
    // Avoid server-side redirects for auth state that only exists in browser storage.
    return true;
  }

  const accountKeys = window.localStorage.getItem("msal.account.keys");
  if (accountKeys) {
    try {
      const parsed = JSON.parse(accountKeys);
      if (Array.isArray(parsed) && parsed.length > 0) return true;
      if (typeof parsed === "string" && parsed.length > 0) return true;
    } catch {
      if (accountKeys.length > 0) return true;
    }
  }

  // Fallback for MSAL cache key variants across versions.
  return Object.keys(window.localStorage).some(
    (key) => key.startsWith("msal.") && key.includes("account"),
  );
}

export function adminRouteLoader({ request }: LoaderFunctionArgs) {
  if (hasCachedMsalAccount()) return null;

  const { pathname, search } = new URL(request.url);
  const target = `${pathname}${search}`;
  return redirect(`/admin/login?redirect=${encodeURIComponent(target)}`);
}
